var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.payload.weigth, _vm.payload.alignment]},[_c('p',{staticClass:"h2"},[_vm._v(_vm._s(_vm.payload.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }